import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { IconButton, Icon } from '@mui/material';

interface ErrorMessageProps {
  message: string; // Message to display
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
    }
  }, [message]);

  const onClickClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null; // Don't render anything if not visible
  }

  return ReactDOM.createPortal(
    <div className="error-message">
     <IconButton
        color="secondary"
        size="small"
        onClick={onClickClose}
      >
        <Icon>close</Icon>
      </IconButton>
      <div className="message">Error: {message}</div>
    </div>,
    document.body
  );
};

export default ErrorMessage;
